export enum Roles {
  Marketer = 2,
  SalesManager = 3,
  SalesRepresentative = 4,
}
